import { Link } from "react-router-dom";

function BoltIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <path d="M13 2L4 14h7l-1 8 10-14h-7l0-6z" fill="#7B5CFF" />
    </svg>
  );
}

function HeartIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <path
        d="M12 20s-7-4.4-7-10a4.2 4.2 0 017-3 4.2 4.2 0 017 3c0 5.6-7 10-7 10z"
        fill="#F06292"
      />
    </svg>
  );
}

function PeopleIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
      <circle cx="9" cy="9" r="3" fill="#4FC3F7" />
      <circle cx="16.5" cy="10" r="2.5" fill="#81D4FA" />
      <path
        d="M3.5 18.5c.8-3 3-4.5 5.5-4.5s4.7 1.5 5.5 4.5"
        fill="none"
        stroke="#4FC3F7"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13.5 18.5c.5-2 1.8-3.2 3.5-3.2 1.4 0 2.5.8 3.1 2.2"
        fill="none"
        stroke="#81D4FA"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="login_footer">
      <div className="feature_bar">
        <div className="feature_item">
          <span className="feature_icon">
            <BoltIcon />
          </span>
          <div>
            <strong>Instant Connect</strong>
            <span>Stay connected in real-time</span>
          </div>
        </div>
        <div className="feature_item">
          <span className="feature_icon">
            <HeartIcon />
          </span>
          <div>
            <strong>Share Moments</strong>
            <span>Beautifully &amp; effortlessly</span>
          </div>
        </div>
        <div className="feature_item">
          <span className="feature_icon">
            <PeopleIcon />
          </span>
          <div>
            <strong>Community First</strong>
            <span>Because together is better</span>
          </div>
        </div>
      </div>

      <div className="login_footer_wrap">
        <span className="footer_copy">
          © {new Date().getFullYear()} UsmaApp · Atozas
        </span>
        <nav className="footer_links">
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
        </nav>
      </div>
    </footer>
  );
}
